// eslint-disable-next-line no-restricted-imports
import { ScrollView } from 'dripsy';

export default ScrollView;
